import { render, staticRenderFns } from "./ClientesReativados.vue?vue&type=template&id=7b41cb50"
import script from "./ClientesReativados.vue?vue&type=script&lang=js"
export * from "./ClientesReativados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports